module.exports = __webpack_public_path__ + "img/Puente_Istobal_MNEX32_Alto_Blanco-default-back.33457e3b.jpg";